// ─── Sous-module « inv-photos » — bandeau de photos d'un article ──
// Ajout depuis l'appareil photo ou la galerie, suppression par appui long.
// expo-image-picker est chargé PARESSEUSEMENT : une app de la suite qui ne
// monte pas ce module n'a pas à l'installer.
import React, { useMemo, useState } from 'react';
import { View, Text, Image, TouchableOpacity, ScrollView, StyleSheet, ActivityIndicator, Platform } from 'react-native';
import { useUI, useT, uploadFichier, supprimerFichier, confirmerSuppression, VisionneuseImage } from '@mop/core';

let ImagePicker = null;
try { ImagePicker = require('expo-image-picker'); } catch (_) { /* absent → boutons masqués */ }

export default function PhotosArticle({ photos = [], dossier, onChange, lecture = false }) {
  const UI = useUI();
  const t = useT();
  const s = useMemo(() => makeStyles(UI), [UI]);
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState('');
  const [zoom, setZoom] = useState(null);   // photo ouverte en plein écran

  async function ajouter(depuisCamera) {
    if (!ImagePicker || busy) return;
    setBusy(true); setErr('');
    try {
      if (depuisCamera) {
        const perm = await ImagePicker.requestCameraPermissionsAsync();
        if (!perm.granted) { setErr(t('commun.accesCameraRefuse')); setBusy(false); return; }
      }
      const res = depuisCamera
        ? await ImagePicker.launchCameraAsync({ quality: 0.6 })
        : await ImagePicker.launchImageLibraryAsync({ quality: 0.6, mediaTypes: ['images'] });
      if (!res.canceled && res.assets?.[0]?.uri) {
        const { url, chemin } = await uploadFichier(res.assets[0].uri, dossier);
        onChange([...(photos || []), { url, chemin }]);
      }
    } catch (e) { setErr(e?.message || String(e)); }
    setBusy(false);
  }

  function retirer(p, i) {
    confirmerSuppression(t('inventaire.supprPhotoTitre'), t('inventaire.supprPhotoMsg'), async () => {
      onChange((photos || []).filter((_, j) => j !== i));
      supprimerFichier(p.chemin);          // best-effort, le lien est déjà retiré
    });
  }

  return (
    <View>
      <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={s.bande}>
        {(photos || []).map((p, i) => (
          <TouchableOpacity key={(p.chemin || p.url) + i} activeOpacity={0.8}
            onPress={() => setZoom(p.url)}
            onLongPress={lecture ? undefined : () => retirer(p, i)} delayLongPress={450}>
            <Image source={{ uri: p.url }} style={s.vignette} />
          </TouchableOpacity>
        ))}
        {!lecture && !!ImagePicker && (
          <>
            {Platform.OS !== 'web' && (
              <TouchableOpacity style={s.ajout} onPress={() => ajouter(true)} disabled={busy}>
                <Text style={s.ajoutIc}>📷</Text>
                <Text style={s.ajoutTxt}>{t('inventaire.photo')}</Text>
              </TouchableOpacity>
            )}
            <TouchableOpacity style={s.ajout} onPress={() => ajouter(false)} disabled={busy}>
              <Text style={s.ajoutIc}>🖼️</Text>
              <Text style={s.ajoutTxt}>{t('repas.photoGalerie')}</Text>
            </TouchableOpacity>
          </>
        )}
        {busy && <View style={s.ajout}><ActivityIndicator color={UI.accent} /></View>}
      </ScrollView>
      {!!err && <Text style={s.err}>{err}</Text>}
      {!lecture && (photos || []).length > 0 && <Text style={s.aide}>{t('inventaire.photosAide')}</Text>}
      <VisionneuseImage url={zoom} onFermer={() => setZoom(null)} />
    </View>
  );
}

const makeStyles = (UI) => StyleSheet.create({
  bande:    { flexDirection: 'row', gap: 8, paddingVertical: 2 },
  vignette: { width: 74, height: 74, borderRadius: 10, backgroundColor: UI.champ },
  ajout:    { width: 74, height: 74, borderRadius: 10, borderWidth: 1, borderColor: UI.border,
              borderStyle: 'dashed', alignItems: 'center', justifyContent: 'center', gap: 2 },
  ajoutIc:  { fontSize: 20 },
  ajoutTxt: { fontSize: 10.5, color: UI.muted, fontWeight: '600' },
  aide:     { fontSize: 11, color: UI.faint, marginTop: 6 },
  err:      { fontSize: 11.5, color: UI.danger, marginTop: 6 },
});
